var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMac = function SvgMac(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.5 12c0 5.796-4.699 10.5-10.5 10.5S1.5 17.796 1.5 12C1.5 6.199 6.199 1.5 12 1.5S22.5 6.199 22.5 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mac_svg__a)",
    d: "M16.125 4.5h1.125l-4.5 7.5 4.5 7.5h-1.125L12 12.75 7.875 19.5H6.75l4.5-7.5-4.5-7.5h1.125L12 11.25z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mac_svg__a",
    x1: 12,
    x2: 12,
    y1: 4.5,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#8396B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#A37F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5031"
  })))));
};
export default SvgMac;